import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useShopLoader } from '../hooks/useShopLoader';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { shop, loading: shopLoading } = useShopLoader();

  // Show loading if either auth or shop is still loading
  if (authLoading || (isAuthenticated && shopLoading)) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#1f2937] to-[#111827] flex items-center justify-center">
        <div className="text-center text-white">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#a15507] mx-auto mb-4"></div>
          <p className="text-gray-300">Loading your coffee shop...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    // If user has a shop, redirect to dashboard
    if (shop) {
      return <Navigate to="/dashboard" replace />;
    }
    // If user doesn't have a shop, redirect to onboarding
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default PublicRoute; 